import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svg-delete",
  "use": "icon-svg-delete-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-svg-delete\">\n<style type=\"text/css\">\n</style>\n<path class=\"st0\" d=\"M31,55.2h138v131c0,7.6-6.2,13.8-13.8,13.8H44.9c-7.6,0-13.8-6.2-13.8-13.8L31,55.2L31,55.2z M79.3,13.8V0h41.4\n\tv13.8h55.2v27.6H24.2V13.8H79.3L79.3,13.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol